import { useQuery } from '@tanstack/react-query';

import Api from '@/services/api';
import { QUERY_KEYS } from '@/utils/query-keys';
import type { AxiosErrorResponse, BaseReportsPaginated, BaseReportsPaginatedResponse, PaginatedData } from '@/types';

export type ListAllKimMhoDTO = BaseReportsPaginated;

export type ListAllKimMhoResponse = PaginatedData<BaseReportsPaginatedResponse>;

async function listKimMhoPaginated(params: ListAllKimMhoDTO): Promise<ListAllKimMhoResponse> {
	const url = '/ergonomic-tool/kim-mho/reports/list-all';
	const { data } = await Api.get<ListAllKimMhoResponse>(url, {
		params
	});
	return data;
}

export const useListKimMhoPaginated = ({
	limit,
	offset,
	sector_id,
	company_id,
	cellule_id,
	report_name,
	activity_id,
	evaluator_id,
	original_name,
	created_at_end,
	workstation_id,
	organization_id,
	created_at_start,
	isSelectedReport
}: ListAllKimMhoDTO) => {
	const enabled = !!limit && !!isSelectedReport && offset >= 0;
	const kimMhoReport = useQuery<ListAllKimMhoResponse, AxiosErrorResponse>(
		[
			QUERY_KEYS.GET_KIM_MHO_REPORTS_PAGINATED,
			[
				limit,
				offset,
				sector_id,
				company_id,
				cellule_id,
				activity_id,
				report_name,
				evaluator_id,
				original_name,
				created_at_end,
				workstation_id,
				organization_id,
				created_at_start
			]
		],
		() =>
			listKimMhoPaginated({
				limit,
				offset,
				sector_id,
				cellule_id,
				company_id,
				report_name,
				activity_id,
				evaluator_id,
				original_name,
				created_at_end,
				workstation_id,
				organization_id,
				created_at_start
			}),
		{
			enabled,
			retry: 0
		}
	);
	return kimMhoReport;
};
